import React from 'react';
import './Form.css'

const Form = () => {
    return (
        <div className='wrapper'>
            <div className='contact-form'>
                <div className='input-fields'>
                    <h1>Contact Us</h1>
                    <br />
                    <form name='submition-form' method='POST' data-netlify='true'>
                        <input type='hidden' className='input' name='form-name' value='submition-form' />
                        <input type='text' className='input' placeholder='Name' name='name' />  
                        <input type='text' className='input' placeholder='Email' name='email' />
                        <input type='text' className='input' placeholder='Subject' name='subject' />
                        <div className='msg'>
                          <textarea placeholder='Message' name='message'></textarea>
                          <button className='btn' type='submit'>Send</button> 
                        </div>
                        
                          
                    </form>
                </div>
            </div>
        </div>
        
    )
}

export default Form;
